import { render, staticRenderFns } from "./DestinationSelect.vue?vue&type=template&id=96441e98&lang=pug&"
import script from "./DestinationSelect.vue?vue&type=script&lang=js&"
export * from "./DestinationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports